<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">

                <!-- Promotion -->
                <div class="promotion_area ptb80">
                    <div class="company_header">
                       <!-- 로고 -->
                       <div class="company_logo" v-if="company.img_path">
                           <img :src="logoUrl" alt="company logo" />
                       </div>

                       <!-- 회사명 -->
                       <h2 class="company_name">
                           {{ company.company }}
                       </h2>

                       <!-- 외부 링크 -->
                       <!--div class="company_link" v-if="company.url">
                           <a :href="company.url" target="_blank" rel="noopener noreferrer">
                               {{ company.url }}
                           </a>
                       </div!-->
                   </div>    

                    <!-- Slider -->
                    <div class="banner" v-if="slides.length">
                        <swiper
                            :modules="modules"
                            :slides-per-view="1"
                            :loop="true"
                            :autoplay="{ delay: 3000 }"
                            :navigation="true"
                            :pagination="{ clickable: true }"
                            class="main_banner_swiper"
                        >
                            <swiper-slide
                                v-for="(img, index) in slides"
                                :key="index"
                            >
                                <div class="item">
                                    <img :src="img" alt="slide image">
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>

                <!-- Catalog -->
                <div class="promotion info" v-if="company.catalog">
                    <h2>더 많은 정보를 보려면?</h2>
                    <div class="id_card">
                        <a v-if="company.url"
                           :href="company.url"
                           target="_blank"
                           rel="noopener noreferrer"
                           class="external_link">
                            <span class="material-symbols-outlined">add_home</span>
                        </a>    
                        <a :href="catalogUrl" target="_blank" download>
                            <span class="material-symbols-outlined">attach_file</span>
                            <p>카탈로그.pdf</p>
                        </a>
                    </div>
                </div>

            </div>
        </main>
        <TheFooter />
    </div>
</template>
<script>
import api from '@/api'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Autoplay, Navigation, Pagination } from 'swiper/modules'

import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'BIPV_Modul',
    components: {
        TheHeader,
        TheFooter,
        Swiper,
        SwiperSlide
    },

    data() {
        return {
            company: {},
            slides: [],
            catalogUrl: '',
            logoUrl: '',
            modules: [Autoplay, Navigation, Pagination]
        }
    },

    mounted() {
        this.fetchCompany()
    },

    methods: {
        async fetchCompany() {
            const id = this.$route.query.id
            if (!id) return

            try {
                const res = await api.get('/admin/zebcompany_view', {
                    params: { id }
                })

                this.company = res.data

                const base = api.defaults.baseURL.replace(/\/$/, '')

                // slide1 ~ slide5 처리
                const slideKeys = ['slide1','slide2','slide3','slide4','slide5']
                this.slides = slideKeys
                    .map(k => res.data[k])
                    .filter(v => v)
                    .map(v => `${base}/${v.replace(/^\//, '')}`)

                // catalog 파일
                if (res.data.catalog) {
                    this.catalogUrl = `${base}/${res.data.catalog.replace(/^\//, '')}`
                }

                // logo 파일
                if (res.data.img_path) {
                    this.logoUrl = `${base}/${res.data.img_path.replace(/^\//, '')}`
                }

            } catch (e) {
                console.error('ZebCompany 로딩 실패', e)
            }
        }
    }
}
</script>
